import { BreakPoints, BreakPointsNext } from '../constants';
import setMediaBreakpoints from './setMediaBreakpoints';

const setupMediaQueryListeners = (
  matchMedia,
  useMediaQueryNext,
) => dispatch => {
  const breakPoints = useMediaQueryNext ? BreakPointsNext : BreakPoints;
  const media = Object.entries(breakPoints).map(([name, value]) => [
    name,
    matchMedia(`(min-width: ${value}em)`),
  ]);
  const commonHandler = () =>
    dispatch(
      setMediaBreakpoints(
        media.reduce(
          (acc, [name, query]) => ({ ...acc, [name]: query.matches }),
          {},
        ),
      ),
    );

  media.forEach(([, q]) => q.addListener(commonHandler), media);

  commonHandler();
};

export default setupMediaQueryListeners;
